exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".expand-link[data-v-69cb8d2f]:hover{text-decoration:underline}.label[data-v-69cb8d2f]{font-size:14px;font-size:.875rem}.description[data-v-69cb8d2f]{font-size:12px;font-size:.75rem}.outline[data-v-69cb8d2f]{border:1px solid #e9ecef}", ""]);

